/** @format */

import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../../../Css/Dashboard/leftMenu.css";

//Icons Import
import DashboardIcon from "../../../Assets/Icons/Dashboard.svg";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ShopTwoOutlinedIcon from "@mui/icons-material/ShopTwoOutlined";
import RegisteredUserIcon from "../../../Assets/Icons/Active_Customer_Count.svg";
import PackageAndPlansIcon from "../../../Assets/Icons/money_1_.svg";
import FloorPlanApprovalIcon from "../../../Assets/Icons/blueprint.svg";
import OffersIcon from "../../../Assets/Icons/Offers.svg";
import TaxIcon from "../../../Assets/Icons/tax.svg";
import SmsIcon from "../../../Assets/Icons/speech-bubble.svg";
import RefundIcon from "../../../Assets/Icons/return-of-investment.svg";
import CustomerSupportIcon from "../../../Assets/Icons/customer-support.svg";
import DeviceSettingsIcon from "../../../Assets/Icons/settings.svg";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


//Images Import
import ManImg from "../../../Assets/Images/man.jpg";
import { ListItem, ListItemIcon, Tooltip } from "@mui/material";
const LeftMenu = () => {
  const [activeTab, setActiveTab] = useState();
  const [reportShow, setReportshow] = useState(false);
  const [showOffer, setShowOffer] = useState(false);
  const [showSms, setShowSms] = useState(false);
  const [showMarketing,setShowMarketing]=useState(false)
  const [showStaff,setShowStaff]=useState(false)
  const [showHrm,setShowHrm]=useState(false)
  const [showQuery,setShowQuery]=useState(false)
  const [showLeave,setShowLeave]=useState(false)
  const [showPayroll,setShowPayroll]=useState(false)
  const [showLoan,setShowLoan]=useState(false)
  const [showRegisterdCustomer,setShowRegisteredCustomer]=useState(false)

  // offers Menu
  const offersMenu = () => {
    setShowOffer(!showOffer);
  };

  //Report OnClick
  const ReportClick = () => {
    setReportshow(!reportShow);
  };

  //SmsOnclick

  const SMSOnclick = () => {
    setShowSms(!showSms);
  };
  // customer onClick
  const marketingOnClick=()=>{
    setShowMarketing(!showMarketing)
  }
  // staff menu click
  const staffMenuClick=()=>{
    setShowStaff(!showStaff)
  }
  const hrmClick=()=>{
    setShowHrm(!showHrm)
  }
  const marketingQueryClick=()=>{
    setShowQuery(!showQuery)
  }
  const leaveOnclick=()=>{
    setShowLeave(!showLeave)
  }
  const payrollClick=()=>{
    setShowPayroll(!showPayroll)
  }

  const loanClick=()=>{
    setShowLoan(!showLoan)
  }
  const registeredCustomerClick=()=>{
    setShowRegisteredCustomer(!showRegisterdCustomer)
  }
 

  return (
    <div className="left-menu-parent-container" id="leftMenu">
      {/* Profile Info  */}
      <div className="profile-info-container">
        <img src={ManImg} alt="Avatar" className="avatar-img" />
        <p>Salvatore</p>
      </div>

      {/* Menu Items  */}
      <ul>
          {/* dashboard */}
          <li className={activeTab === "dashboard" ? "focused" : ""}>
            <NavLink
              to="homeDashboard"
              style={(isActive) => isActive && setActiveTab("dashboard")}
            >
              {/* <img src={DashboardIcon} alt="dashboard icon" /> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="216.031"
                height="144.074"
                viewBox="0 0 216.031 144.074"
              >
                <g
                  id="Group_5636"
                  data-name="Group 5636"
                  transform="translate(-15.283 -123.123)"
                >
                  <g
                    id="Group_10"
                    data-name="Group 10"
                    transform="translate(23.38 130.324)"
                  >
                    <g id="Group_9" data-name="Group 9">
                      <path
                        id="Path_465"
                        data-name="Path 465"
                        d="M43.79,203.733H15.881v14.415H43.79a7.208,7.208,0,0,0,0-14.415ZM108.6,124.617v27.855a7.2,7.2,0,0,0,14.4,0V123.654h-7.2Zm79.211,79.116a7.208,7.208,0,0,0,0,14.415h24.3V203.733Z"
                        transform="translate(-15.881 -123.654)"
                        // fill="#fff"
                      />
                    </g>
                  </g>
                  <path
                    id="Path_466"
                    data-name="Path 466"
                    d="M123.3,123.123A107.817,107.817,0,0,0,21.563,267.2H225.035A107.817,107.817,0,0,0,123.3,123.123ZM103.364,252.8a20.992,20.992,0,0,1,39.87,0Zm53.268-6.306,42.175-60.714-60.076,41.809c.176.095.325.217.488.3a35.362,35.362,0,0,0-15.921-3.906A35.823,35.823,0,0,0,88.284,252.8H32.29a91.585,91.585,0,0,1-2.6-21.616,93.613,93.613,0,1,1,187.226,0,91.584,91.584,0,0,1-2.6,21.616H158.314"
                    transform="translate(0 0)"
                    // fill="#fff"
                  />
                </g>
              </svg>
              {/* <svg>
              <use xlinkHref={'../../../Assets/Icons/Dashboard.svg'}/>
            </svg> */}
              <span className="menu-label">Dashboard</span>
            </NavLink>
          </li>

          <li className={activeTab === "catalog" ? "focused" : ""}>
            <NavLink
              to="catalog"
              style={(isActive) => isActive && setActiveTab("catalog")}
            >
              {/* <img src={DashboardIcon} alt="dashboard icon" /> */}
             
              {/* <svg>
              <use xlinkHref={'../../../Assets/Icons/Dashboard.svg'}/>
            </svg> */}
              <span className="menu-label">Catalog</span>
            </NavLink>
          </li>
        
          {/* registerd user */}
          <li onClick={registeredCustomerClick}>
            <NavLink
              className="icon-tool-tip-container"
              to="registeredCustomerList"
              style={(isActive) => isActive && setActiveTab("registeredUser")}
            >
              <div style={{display:"flex",alignItems:"center",width:"80%"}}>
              <svg
                id="user_4_"
                data-name="user(4)"
                xmlns="http://www.w3.org/2000/svg"
                width="298.178"
                height="298.758"
                viewBox="0 0 298.178 298.758"
              >
                <path
                  id="Path_1192"
                  data-name="Path 1192"
                  d="M140.3-511.314a84.566,84.566,0,0,0-29.012,9.807A79.328,79.328,0,0,0,83.857-389.662a83.8,83.8,0,0,0,14.71,16.987c2.218,1.867,3.911,3.56,3.619,3.736-.234.175-3.678,1.634-7.647,3.152a145.815,145.815,0,0,0-48.976,31.58A148.709,148.709,0,0,0,6.278-271.98c-6.363,19.206-6.655,28.428-1.4,39.228A36.757,36.757,0,0,0,22.1-216.174c7,3.152,6.071,3.152,73.435,2.978l62.344-.176,2.393-1.576c3.619-2.394,5.137-5.254,5.137-9.807s-1.518-7.413-5.137-9.806l-2.393-1.577-62.46-.292c-56.856-.291-62.694-.408-64.27-1.283-3.911-2.1-6.713-6.6-6.713-10.624,0-2.627,2.919-13.835,5.254-20.2a161.566,161.566,0,0,1,13.251-26.385,129.6,129.6,0,0,1,51.194-45.065c17.512-8.581,32.748-12.259,54.346-13.193,6.771-.292,14.36-.935,16.929-1.4a80.333,80.333,0,0,0,56.214-42.73,100.537,100.537,0,0,0,6.888-20.373c1.459-7.122,1.518-22.357.058-29.6a80.2,80.2,0,0,0-47.05-58.316A81.8,81.8,0,0,0,140.3-511.314Zm23.7,24.4a53.557,53.557,0,0,1,26.21,15.178,56.074,56.074,0,0,1,15,26.676c1.4,5.546,1.4,19.439,0,24.985-4.378,17.4-16.753,32.223-32.573,38.935-32.106,13.661-68.239-4.669-76.82-38.935-1.4-5.546-1.4-19.439,0-24.985a56.228,56.228,0,0,1,15.236-26.969c9.223-9.165,17.8-13.485,32.456-16.228C146.959-488.9,159.685-488.081,164-486.914Z"
                  transform="translate(-1.198 511.894)"
                />
                <path
                  id="Path_1193"
                  data-name="Path 1193"
                  d="M330.79-199.241c-2.744.817-6.363,4.612-7.18,7.647a12.072,12.072,0,0,0,5.137,13.368l2.218,1.4h95.15l2.218-1.4a12.719,12.719,0,0,0,3.619-3.444c1.226-1.81,1.459-2.8,1.459-6.538s-.233-4.728-1.459-6.538a12.714,12.714,0,0,0-3.619-3.444l-2.218-1.4-46.7-.117C350.987-199.766,331.957-199.591,330.79-199.241Z"
                  transform="translate(-135.235 381.949)"
                />
                <path
                  id="Path_1194"
                  data-name="Path 1194"
                  d="M330.79-119.241c-2.744.817-6.363,4.612-7.18,7.647a12.072,12.072,0,0,0,5.137,13.368l2.218,1.4h95.15l2.218-1.4a12.717,12.717,0,0,0,3.619-3.444c1.226-1.81,1.459-2.8,1.459-6.538s-.233-4.728-1.459-6.538a12.717,12.717,0,0,0-3.619-3.444l-2.218-1.4-46.7-.117C350.987-119.766,331.957-119.591,330.79-119.241Z"
                  transform="translate(-135.235 348.648)"
                />
                <path
                  id="Path_1195"
                  data-name="Path 1195"
                  d="M330.79-39.241c-2.744.817-6.363,4.612-7.18,7.647a12.072,12.072,0,0,0,5.137,13.368l2.218,1.4h95.15l2.218-1.4a12.717,12.717,0,0,0,3.619-3.444c1.226-1.81,1.459-2.8,1.459-6.538s-.233-4.728-1.459-6.538a12.719,12.719,0,0,0-3.619-3.444l-2.218-1.4-46.7-.117C350.987-39.766,331.957-39.591,330.79-39.241Z"
                  transform="translate(-135.235 315.347)"
                />
              </svg>
              <span className="menu-label">Registered Customer</span>
              </div>
              {showRegisterdCustomer?<ExpandMoreIcon/>:<KeyboardArrowRightIcon/>}
             
            </NavLink>
          </li>
          {
            showRegisterdCustomer && (
              <>
              <li className="hidden-li">
                <NavLink
                  to="registeredCustomerList"
                  style={(isActive) => isActive && setActiveTab("registeredUser")}
                >
                  {/* <img src={OffersIcon} alt="dashboard icon" /> */}
                  <span className="menu-label">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Customer List
                  </span>
                </NavLink>
              </li>
              <li className="hidden-li">
                <NavLink
                  to="customerRegistration"
                  style={(isActive) => isActive && setActiveTab("registeredUser")}
                >
                  {/* <img src={OffersIcon} alt="dashboard icon" /> */}
                  <span className="menu-label">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Customer Registration
                  </span>
                </NavLink>
              </li>
          </>
            )
          }
        
           {/* package and plans */}
          <li>
            <NavLink
              to="packagesAndplans"
              style={(isActive) => isActive && setActiveTab("packagesAndplans")}
            >
              {/* <img src={PackageAndPlansIcon} alt="dashboard icon" /> */}
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="514.000000pt"
                height="514.000000pt"
                viewBox="0 0 520.000000 520.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  stroke="none"
                >
                  <path
                    d="M3230 4253 c-290 -43 -504 -118 -710 -246 -607 -379 -916 -1097 -770
-1794 122 -584 558 -1077 1119 -1263 178 -60 293 -80 479 -87 324 -12 572 43
852 188 160 83 287 176 415 304 257 257 416 561 481 920 25 139 25 431 0 570
-133 731 -705 1292 -1428 1399 -96 15 -367 20 -438 9z m405 -308 c141 -22 259
-60 390 -124 400 -196 678 -552 765 -983 67 -327 12 -679 -151 -963 -216 -377
-582 -632 -1004 -700 -118 -20 -327 -19 -446 1 -290 48 -550 184 -764 399
-207 207 -340 460 -391 745 -23 127 -23 353 0 480 81 451 384 844 798 1034 93
43 251 92 353 110 107 19 338 20 450 1z"
                  />
                  <path
                    d="M3270 3448 l0 -123 -60 -28 c-35 -16 -85 -52 -119 -85 -181 -178
-189 -461 -18 -648 83 -91 184 -139 323 -153 67 -7 91 -14 119 -35 47 -36 67
-78 67 -138 -1 -60 -35 -118 -84 -145 -50 -26 -128 -23 -171 7 -39 27 -77 85
-77 119 0 20 -4 21 -150 21 l-150 0 0 -32 c1 -143 121 -320 260 -385 l60 -28
0 -123 0 -123 148 3 147 3 3 121 3 120 55 27 c107 53 198 161 236 280 22 71
26 190 8 258 -52 195 -250 349 -448 349 -21 0 -58 10 -82 23 -153 76 -97 312
74 311 28 0 65 -8 83 -17 40 -21 83 -83 83 -119 l0 -28 153 0 154 0 -8 59
c-22 157 -117 291 -255 359 l-53 26 -3 120 -3 121 -147 3 -148 3 0 -123z"
                  />
                  <path d="M360 3420 l0 -150 465 0 465 0 0 150 0 150 -465 0 -465 0 0 -150z" />
                  <path d="M0 2560 l0 -150 645 0 645 0 0 150 0 150 -645 0 -645 0 0 -150z" />
                  <path d="M360 1700 l0 -150 465 0 465 0 0 150 0 150 -465 0 -465 0 0 -150z" />
                </g>
              </svg>
              <span className="menu-label">Package & Plans</span>
            </NavLink>
          </li>

            {/* trial period */}
            <li>
            <NavLink
              to="trialPeriod"
              style={(isActive) => isActive && setActiveTab("trialPeriod")}
            >
              {/* <img src={PackageAndPlansIcon} alt="dashboard icon" /> */}
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="514.000000pt"
                height="514.000000pt"
                viewBox="0 0 520.000000 520.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  stroke="none"
                >
                  <path
                    d="M3230 4253 c-290 -43 -504 -118 -710 -246 -607 -379 -916 -1097 -770
-1794 122 -584 558 -1077 1119 -1263 178 -60 293 -80 479 -87 324 -12 572 43
852 188 160 83 287 176 415 304 257 257 416 561 481 920 25 139 25 431 0 570
-133 731 -705 1292 -1428 1399 -96 15 -367 20 -438 9z m405 -308 c141 -22 259
-60 390 -124 400 -196 678 -552 765 -983 67 -327 12 -679 -151 -963 -216 -377
-582 -632 -1004 -700 -118 -20 -327 -19 -446 1 -290 48 -550 184 -764 399
-207 207 -340 460 -391 745 -23 127 -23 353 0 480 81 451 384 844 798 1034 93
43 251 92 353 110 107 19 338 20 450 1z"
                  />
                  <path
                    d="M3270 3448 l0 -123 -60 -28 c-35 -16 -85 -52 -119 -85 -181 -178
-189 -461 -18 -648 83 -91 184 -139 323 -153 67 -7 91 -14 119 -35 47 -36 67
-78 67 -138 -1 -60 -35 -118 -84 -145 -50 -26 -128 -23 -171 7 -39 27 -77 85
-77 119 0 20 -4 21 -150 21 l-150 0 0 -32 c1 -143 121 -320 260 -385 l60 -28
0 -123 0 -123 148 3 147 3 3 121 3 120 55 27 c107 53 198 161 236 280 22 71
26 190 8 258 -52 195 -250 349 -448 349 -21 0 -58 10 -82 23 -153 76 -97 312
74 311 28 0 65 -8 83 -17 40 -21 83 -83 83 -119 l0 -28 153 0 154 0 -8 59
c-22 157 -117 291 -255 359 l-53 26 -3 120 -3 121 -147 3 -148 3 0 -123z"
                  />
                  <path d="M360 3420 l0 -150 465 0 465 0 0 150 0 150 -465 0 -465 0 0 -150z" />
                  <path d="M0 2560 l0 -150 645 0 645 0 0 150 0 150 -645 0 -645 0 0 -150z" />
                  <path d="M360 1700 l0 -150 465 0 465 0 0 150 0 150 -465 0 -465 0 0 -150z" />
                </g>
              </svg>
              <span className="menu-label">Trial Period</span>
            </NavLink>
          </li>
        
          {/* floor plan approval */}
          {/* <li>
            <NavLink
              to="floorPlanApprove"
              style={(isActive) => isActive && setActiveTab("floorPlanApprove")}
            >
           
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="512.000000pt"
                height="512.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
                  <path
                    d="M62 5105 c-66 -29 -62 78 -62 -1655 0 -1311 2 -1576 14 -1604 24 -57
65 -68 228 -64 l140 3 29 33 c38 43 41 107 5 145 -28 30 -47 36 -131 39 l-60
3 -3 333 -2 332 335 0 335 0 0 -60 c0 -80 20 -125 63 -146 48 -23 98 -12 131
27 l26 31 0 263 0 263 -31 31 c-46 46 -107 46 -154 0 -27 -27 -30 -36 -33
-109 l-4 -80 -332 2 -331 3 -3 1003 -2 1002 1115 0 1115 0 0 -1005 0 -1005
-222 2 -223 3 -3 77 c-3 71 -5 80 -33 108 -46 45 -108 45 -154 -1 l-30 -29 -3
-249 c-2 -204 0 -256 12 -285 30 -73 129 -86 180 -25 23 27 26 40 26 105 l0
74 225 0 225 0 0 -335 0 -335 -70 0 c-81 0 -120 -16 -138 -55 -29 -63 -6 -126
54 -151 48 -20 480 -20 528 0 62 26 84 92 52 155 -20 38 -55 51 -136 51 l-70
0 0 335 0 335 225 0 225 0 0 -74 c0 -65 3 -78 26 -105 51 -61 150 -48 180 25
12 29 14 81 12 285 l-3 249 -30 29 c-46 46 -108 46 -154 1 -28 -28 -30 -37
-33 -108 l-3 -77 -222 -3 -223 -2 0 1005 0 1005 1115 0 1115 0 -2 -1002 -3
-1003 -331 -3 -332 -2 -4 80 c-3 73 -6 82 -33 109 -47 46 -108 46 -154 0 l-31
-31 0 -263 0 -263 26 -31 c33 -39 83 -50 131 -27 43 21 63 66 63 146 l0 60
335 0 335 0 0 -1225 0 -1225 -1115 0 -1115 0 0 335 0 335 65 0 c104 0 155 38
155 113 0 31 -7 46 -34 73 l-34 34 -262 0 -262 0 -34 -34 c-27 -27 -34 -42
-34 -73 0 -75 51 -113 155 -113 l65 0 0 -335 0 -335 -1115 0 -1115 0 0 334 0
334 81 4 c77 3 82 5 110 36 49 55 36 138 -28 171 -13 7 -79 11 -165 11 -157 0
-175 -5 -203 -60 -22 -43 -22 -933 0 -986 29 -69 -177 -64 2545 -64 2138 0
2465 2 2496 15 69 29 64 -177 64 2545 0 2722 5 2516 -64 2545 -53 22 -4944 22
-4994 0z"
                  />
                </g>
              </svg>
              <span className="menu-label">Floor Plan Approval</span>
            </NavLink>
              </li>
          */}
           {/* offers */}
          <li onClick={offersMenu}>
            <NavLink
               className="icon-tool-tip-container"
              to="addOffers"
              style={(isActive) => isActive && setActiveTab("offers")}
            >
              {/* <img src={OffersIcon} alt="dashboard icon" /> */}
              <div style={{display:"flex",alignItems:"center",width:"50%"}}>
             
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="174.98"
                height="174.971"
                viewBox="0 0 174.98 174.971"
              >
                <g
                  id="Group_3074"
                  data-name="Group 3074"
                  transform="translate(0.25 0.25)"
                >
                  <path
                    id="Path_1213"
                    data-name="Path 1213"
                    d="M187.316,497.145a11.876,11.876,0,0,0-20.3-8.368c-.957.957-2.7,3.015-3.643,4.165a2.824,2.824,0,1,0,4.349,3.6c1.488-1.788,2.715-3.2,3.286-3.769a6.285,6.285,0,0,1,4.445-1.855h.029a6.153,6.153,0,0,1,6.185,6.2,6.279,6.279,0,0,1-1.865,4.445,99.981,99.981,0,0,1-9.982,7.653,17.914,17.914,0,0,0-15.461-8.9h-41.4a20.749,20.749,0,0,0-14.785,6.126L15.425,589.189a8.876,8.876,0,0,0,0,12.533l55.439,55.429a8.866,8.866,0,0,0,12.524,0l82.737-82.738a20.788,20.788,0,0,0,6.127-14.794V518.23a17.3,17.3,0,0,0-.358-3.565,108.316,108.316,0,0,0,11.905-9.094A11.909,11.909,0,0,0,187.316,497.145Zm-25.183,73.267L79.4,653.15a3.2,3.2,0,0,1-4.532,0L19.425,597.721a3.207,3.207,0,0,1,0-4.532l82.737-82.738a15.192,15.192,0,0,1,10.794-4.474h41.4a12.277,12.277,0,0,1,10.775,6.426c-3.344,2.213-7.083,4.561-11.045,6.88-.126-.135-.251-.271-.387-.406a11.886,11.886,0,1,0,3.083,5.372c3.45-2.01,6.764-4.068,9.818-6.049v41.417h0A15.166,15.166,0,0,1,162.133,570.413Zm-19.356-41.871a2.835,2.835,0,0,0,3.8,1.256c1.662-.831,3.3-1.7,4.948-2.59a6.216,6.216,0,1,1-10.61-4.329,6.164,6.164,0,0,1,4.4-1.817,6.239,6.239,0,0,1,3.585,1.141q-2.392,1.3-4.861,2.551A2.826,2.826,0,0,0,142.778,528.542Z"
                    transform="translate(-12.835 -485.269)"
                    stroke-width="0.5"
                  />
                  <path
                    id="Path_1214"
                    data-name="Path 1214"
                    d="M24.081,491.227a2.825,2.825,0,0,0-2.822,2.822v59.7a2.827,2.827,0,1,0,5.653,0v-59.7A2.827,2.827,0,0,0,24.081,491.227Z"
                    transform="translate(60.145 -433.653)"
                    stroke-width="0.5"
                  />
                  <path
                    id="Path_1215"
                    data-name="Path 1215"
                    d="M21.588,496.856a11.876,11.876,0,1,0,16.795,0A11.881,11.881,0,0,0,21.588,496.856ZM34.383,509.64a6.214,6.214,0,1,1,0-8.793,6.228,6.228,0,0,1,0,8.793Z"
                    transform="translate(32.923 -414.997)"
                    stroke-width="0.5"
                  />
                  <path
                    id="Path_1216"
                    data-name="Path 1216"
                    d="M26,496.856a11.869,11.869,0,1,0,16.785,0A11.881,11.881,0,0,0,26,496.856ZM38.8,509.64a6.214,6.214,0,1,1,0-8.793A6.223,6.223,0,0,1,38.8,509.64Z"
                    transform="translate(71.154 -414.997)"
                    stroke-width="0.5"
                  />
                </g>
              </svg>
              <span className="menu-label">Offers</span>
              </div>
              {/* <KeyboardArrowRightIcon /> */}
              {showOffer?<ExpandMoreIcon/>:<KeyboardArrowRightIcon/>}
            </NavLink>
          
            {/* {showOffer?<ExpandMoreIcon/>:<KeyboardArrowRightIcon/>} */}
          </li>

        {showOffer && (
          <>
              <li className="hidden-li">
                <NavLink
                  to="addOffers"
                  style={(isActive) => isActive && setActiveTab("offers")}
                >
                  {/* <img src={OffersIcon} alt="dashboard icon" /> */}
                  <span className="menu-label">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Add Offer
                  </span>
                </NavLink>
              </li>
              <li className="hidden-li">
                <NavLink
                  to="offersListed"
                  style={(isActive) => isActive && setActiveTab("offers")}
                >
                  {/* <img src={OffersIcon} alt="dashboard icon" /> */}
                  <span className="menu-label">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Offers
                    Listed
                  </span>
                </NavLink>
              </li>
          </>
        )}

           {/* marketing */}
           <li onClick={marketingOnClick}>
             <NavLink
              className="icon-tool-tip-container"
               to="customerList"
               style={(isActive)=>isActive  && setActiveTab("customerList")}
             >
             <div style={{display:"flex",alignItems:"center",width:"50%"}}>
             <svg 
             xmlns="http://www.w3.org/2000/svg" 
             width="28.756" 
             height="30.383" 
             viewBox="0 0 28.756 30.383"
             preserveAspectRatio="xMidYMid meet"
             >
 
            <g id="megaphone" transform="translate(-16.186 511.178)">
    <path id="Path_1367" data-name="Path 1367" d="M334.564-510.994a.581.581,0,0,0-.173.316c-.006.077-.107,1.126-.232,2.342a15.26,15.26,0,0,0-.173,2.359.574.574,0,0,0,.947.179.583.583,0,0,0,.173-.286c0-.06.107-1.114.232-2.342a8.588,8.588,0,0,0,.155-2.425A.563.563,0,0,0,334.564-510.994Z" transform="translate(-298.852)" fill="#fff"/>
    <path id="Path_1368" data-name="Path 1368" d="M26.441-443.877a2.437,2.437,0,0,0-1,.679c-.083.107-1.233,2.389-2.55,5.065l-2.4,4.862-1.43.959c-1.65,1.108-2.133,1.549-2.491,2.27a3.482,3.482,0,0,0-.381,1.9,3.415,3.415,0,0,0,.649,1.978,3.689,3.689,0,0,0,3,1.758,3.552,3.552,0,0,0,1.9-.369c.328-.167.429-.2.483-.137.036.042,1.025,1.49,2.2,3.223a40.054,40.054,0,0,0,2.425,3.408,2.414,2.414,0,0,0,1.99.638,2.365,2.365,0,0,0,1.96-1.835,2.284,2.284,0,0,0-.089-1.4c-.054-.155-.977-1.573-2.05-3.152s-1.931-2.9-1.9-2.92,1.335-.143,2.908-.262c5.958-.471,6.113-.483,6.477-.655,1.114-.53,1.662-1.907,1.478-3.706-.5-4.874-5.315-11.267-9.259-12.292A3.963,3.963,0,0,0,26.441-443.877Zm1.889,1.239c1.728.566,3.956,2.556,5.583,4.993,1.77,2.64,2.58,4.814,2.508,6.7A2.047,2.047,0,0,1,35.515-429a1.438,1.438,0,0,1-1.251.1c-2.33-.638-5.285-3.641-7.067-7.186a10.766,10.766,0,0,1-1.323-4.588,2.086,2.086,0,0,1,.495-1.71C26.858-442.882,27.388-442.947,28.329-442.637ZM25.017-438.5a18.49,18.49,0,0,0,6.6,9.563c.268.191.453.352.405.358-.423.072-7.055.548-7.09.512-.083-.1-3.235-4.755-3.259-4.82s3.08-6.477,3.116-6.441C24.8-439.312,24.9-438.943,25.017-438.5Zm-2.854,8.449c.745,1.1,1.43,2.109,1.525,2.24l.167.244-1.2.822c-.661.453-1.347.888-1.513.965a2.542,2.542,0,0,1-2.914-.548,2.667,2.667,0,0,1-.072-3.885c.167-.161,2.622-1.871,2.646-1.847C20.8-432.049,21.418-431.143,22.162-430.047Zm5.291,6.316c1.144,1.686,2.121,3.152,2.163,3.259a1.273,1.273,0,0,1-.787,1.627,1.308,1.308,0,0,1-1.061-.161c-.31-.226-4.671-6.632-4.552-6.7.042-.024.429-.286.852-.584.715-.5.792-.536,1.037-.524l.262.012Z" transform="translate(0 -63.185)" fill="#fff"/>
    <path id="Path_1369" data-name="Path 1369" d="M217.081-347.8a2.857,2.857,0,0,0-1.186.608.745.745,0,0,0-.1.363.444.444,0,0,0,.185.387c.244.22.453.215.912-.03a1.455,1.455,0,0,1,.935-.191,1.568,1.568,0,0,1,.87.149,2.017,2.017,0,0,1,1.078,2.264,2.111,2.111,0,0,1-.834,1.239.546.546,0,0,0-.042.852c.322.322.667.22,1.239-.363a3.2,3.2,0,0,0-.477-4.791A3.508,3.508,0,0,0,217.081-347.8Z" transform="translate(-187.721 -153.569)" fill="#fff"/>
    <path id="Path_1370" data-name="Path 1370" d="M386.883-436.649c-1.74,1.114-3.778,2.491-3.831,2.592a.581.581,0,0,0,.518.846c.209,0,.489-.161,2.282-1.341,1.126-.739,2.121-1.412,2.217-1.5a.547.547,0,0,0-.012-.8C387.783-437.126,387.58-437.09,386.883-436.649Z" transform="translate(-344.945 -69.733)" fill="#fff"/>
    <path id="Path_1371" data-name="Path 1371" d="M399.633-326.911a.568.568,0,0,0-.048.935,47.31,47.31,0,0,0,5.243.971.624.624,0,0,0,.447-.518.381.381,0,0,0-.137-.4c-.143-.161-.238-.209-.614-.274-2.437-.447-4.481-.8-4.594-.8A.85.85,0,0,0,399.633-326.911Z" transform="translate(-360.346 -173.203)" fill="#fff"/>
  </g>
</svg>
              <span className="menu-label">Marketing</span>
              </div>
              {showMarketing?<ExpandMoreIcon/>:<KeyboardArrowRightIcon/>}
             </NavLink>
           </li>

        {showMarketing && (
          <>
              <li className="hidden-li">
                <NavLink
                  to="customerList"
                  style={(isActive)=>isActive  && setActiveTab("marketing")}
                >
                   <span className="menu-label">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Customer List
                  </span>
                </NavLink>
              </li>
              <li className="hidden-li">
                <NavLink
                  to="addCustomer"
                  style={(isActive)=>isActive  && setActiveTab("marketing")}
                >
                   <span className="menu-label">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Add Customer
                  </span>
                </NavLink>
              </li>
               <li className="hidden-li" onClick={marketingQueryClick}>
                 <NavLink
                    className="icon-tool-tip-container"
                    to="requestDemo"
                    style={(isActive) => isActive && setActiveTab("requestDemo")}
                  >
             
                <span className="menu-label">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Enquiry</span>
                {showQuery?<ExpandMoreIcon/>:<KeyboardArrowRightIcon/>}
              {/* <KeyboardArrowRightIcon /> */}
            </NavLink>
          </li>
          {
            showQuery && (
              <>                 
                 <li className="hidden-li">
                   <NavLink
                     to="requestDemo"
                     style={(isActive) => isActive && setActiveTab("requestDemo")}
                   >
                      <span className="menu-label">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Demo Requests
                      </span>
                   </NavLink>
                 </li>
                 <li className="hidden-li">
                   <NavLink
                     to="query"
                     style={(isActive) => isActive && setActiveTab("query")}
                   >
                      <span className="menu-label">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Query
                      </span>
                   </NavLink>
                 </li>
              </>
            )
          }
          </>
        )}
           {/* tax */}
          <li>
            <NavLink
              to="tax"
              style={(isActive) => isActive && setActiveTab("tax")}
            >
              {/* <img src={TaxIcon} alt="dashboard icon" /> */}
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="512.000000pt"
                height="512.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  stroke="none"
                >
                  <path
                    d="M660 2560 l0 -2560 1900 0 1900 0 0 2560 0 2560 -1900 0 -1900 0 0
-2560z m3500 0 l0 -2260 -1600 0 -1600 0 0 2260 0 2260 1600 0 1600 0 0 -2260z"
                  />
                  <path
                    d="M2082 4300 c-167 -39 -207 -262 -64 -361 52 -35 143 -38 202 -7 139
75 137 280 -5 350 -40 21 -93 28 -133 18z"
                  />
                  <path
                    d="M2452 3777 l-532 -532 103 -103 c56 -56 107 -102 112 -102 6 0 249
238 540 530 l530 530 -105 105 c-58 58 -107 105 -110 105 -3 0 -245 -240 -538
-533z"
                  />
                  <path
                    d="M2925 3425 c-54 -19 -111 -84 -123 -141 -26 -122 55 -233 178 -242
67 -4 129 24 174 81 60 75 42 212 -35 269 -64 48 -123 58 -194 33z"
                  />
                  <path
                    d="M1500 2370 l0 -150 1060 0 1060 0 0 150 0 150 -1060 0 -1060 0 0
-150z"
                  />
                  <path
                    d="M1500 1630 l0 -150 1060 0 1060 0 0 150 0 150 -1060 0 -1060 0 0
-150z"
                  />
                  <path d="M1500 890 l0 -150 1060 0 1060 0 0 150 0 150 -1060 0 -1060 0 0 -150z" />
                </g>
              </svg>
              <span className="menu-label">Tax</span>
            </NavLink>
          </li>
          {/* report */}
          <li onClick={ReportClick}>
            <NavLink
              className="icon-tool-tip-container"
              to="dailyreport"
              style={(isActive) => isActive && setActiveTab("sms")}
            >
              <div style={{display:"flex",alignItems:"center",width:"50%"}}>
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="512.000000pt"
                height="512.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  stroke="none"
                >
                  <path
                    d="M660 2560 l0 -2560 1900 0 1900 0 0 2560 0 2560 -1900 0 -1900 0 0
-2560z m3500 0 l0 -2260 -1600 0 -1600 0 0 2260 0 2260 1600 0 1600 0 0 -2260z"
                  />
                  <path
                    d="M2082 4300 c-167 -39 -207 -262 -64 -361 52 -35 143 -38 202 -7 139
75 137 280 -5 350 -40 21 -93 28 -133 18z"
                  />
                  <path
                    d="M2452 3777 l-532 -532 103 -103 c56 -56 107 -102 112 -102 6 0 249
238 540 530 l530 530 -105 105 c-58 58 -107 105 -110 105 -3 0 -245 -240 -538
-533z"
                  />
                  <path
                    d="M2925 3425 c-54 -19 -111 -84 -123 -141 -26 -122 55 -233 178 -242
67 -4 129 24 174 81 60 75 42 212 -35 269 -64 48 -123 58 -194 33z"
                  />
                  <path
                    d="M1500 2370 l0 -150 1060 0 1060 0 0 150 0 150 -1060 0 -1060 0 0
-150z"
                  />
                  <path
                    d="M1500 1630 l0 -150 1060 0 1060 0 0 150 0 150 -1060 0 -1060 0 0
-150z"
                  />
                  <path d="M1500 890 l0 -150 1060 0 1060 0 0 150 0 150 -1060 0 -1060 0 0 -150z" />
                </g>
              </svg>
              <span className="menu-label">Reports</span>
              </div>
              {reportShow?<ExpandMoreIcon/>:<KeyboardArrowRightIcon/>}
            </NavLink>
          </li>

        {reportShow && (
          <>
              <li className="hidden-li">
                <NavLink to="dailyreport">
                  <span className="menu-label">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Daily Report
                  </span>
                </NavLink>
              </li>
              <li className="hidden-li">
                <NavLink to="refundreport">
                  <span className="menu-label">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Refund
                    Report
                  </span>
                </NavLink>
              </li>
          </>
        )}
           {/* report forward */}
          <li>
            <NavLink
              to="reportForward"
              style={(isActive) => isActive && setActiveTab("reportForward")}
            >
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="512.000000pt"
                height="512.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  stroke="none"
                >
                  <path
                    d="M660 2560 l0 -2560 1900 0 1900 0 0 2560 0 2560 -1900 0 -1900 0 0
-2560z m3500 0 l0 -2260 -1600 0 -1600 0 0 2260 0 2260 1600 0 1600 0 0 -2260z"
                  />
                  <path
                    d="M2082 4300 c-167 -39 -207 -262 -64 -361 52 -35 143 -38 202 -7 139
75 137 280 -5 350 -40 21 -93 28 -133 18z"
                  />
                  <path
                    d="M2452 3777 l-532 -532 103 -103 c56 -56 107 -102 112 -102 6 0 249
238 540 530 l530 530 -105 105 c-58 58 -107 105 -110 105 -3 0 -245 -240 -538
-533z"
                  />
                  <path
                    d="M2925 3425 c-54 -19 -111 -84 -123 -141 -26 -122 55 -233 178 -242
67 -4 129 24 174 81 60 75 42 212 -35 269 -64 48 -123 58 -194 33z"
                  />
                  <path
                    d="M1500 2370 l0 -150 1060 0 1060 0 0 150 0 150 -1060 0 -1060 0 0
-150z"
                  />
                  <path
                    d="M1500 1630 l0 -150 1060 0 1060 0 0 150 0 150 -1060 0 -1060 0 0
-150z"
                  />
                  <path d="M1500 890 l0 -150 1060 0 1060 0 0 150 0 150 -1060 0 -1060 0 0 -150z" />
                </g>
              </svg>
              <span className="menu-label">Report Forward</span>
            </NavLink>
          </li>
            {/* sms */}
          <li onClick={SMSOnclick}>
            <NavLink
             className="icon-tool-tip-container"
              to="smsprovider"
              style={(isActive) => isActive && setActiveTab("sms")}
            >
              {/* <img src={SmsIcon} alt="dashboard icon" /> */}
              <div style={{display:"flex",alignItems:"center",width:"50%"}}>

              
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="512.000000pt"
                height="512.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  stroke="none"
                >
                  <path
                    d="M2405 4798 c-789 -35 -1534 -412 -1978 -1000 -208 -275 -337 -570
-399 -908 -25 -136 -30 -461 -9 -595 18 -123 59 -286 97 -398 74 -214 227
-482 373 -654 69 -81 71 -90 47 -216 -35 -182 -114 -316 -284 -483 -63 -62
-110 -114 -105 -116 18 -11 261 -88 307 -98 70 -15 258 -13 347 4 153 29 344
108 484 199 69 45 69 45 105 30 301 -129 572 -201 885 -233 147 -15 470 -13
619 5 679 80 1294 394 1702 868 264 307 425 641 496 1027 30 165 30 495 0 660
-116 631 -496 1162 -1089 1522 -466 283 -1004 413 -1598 386z m475 -273 c475
-59 938 -256 1286 -549 922 -775 923 -2057 1 -2831 -352 -296 -813 -492 -1297
-551 -167 -20 -549 -15 -705 10 -258 42 -464 105 -721 222 l-122 56 -70 -55
c-180 -139 -435 -247 -581 -247 l-41 0 30 49 c91 148 139 313 147 508 l6 132
-70 78 c-551 615 -636 1464 -214 2143 344 553 985 943 1701 1034 149 19 497
20 650 1z"
                  />
                  <path
                    d="M1251 3135 c-174 -49 -259 -158 -249 -319 11 -168 84 -236 399 -373
124 -54 171 -157 108 -237 -46 -59 -251 -76 -404 -35 -44 12 -87 22 -95 23
-22 2 -44 -52 -48 -120 l-4 -62 53 -20 c30 -11 89 -25 131 -32 99 -16 324 -8
392 14 109 35 191 107 220 194 33 96 14 241 -41 315 -43 56 -138 122 -243 168
-213 92 -241 114 -242 189 -1 81 53 119 182 127 52 3 103 -2 165 -16 90 -19
90 -19 107 1 22 25 40 90 36 131 -5 49 -49 60 -248 64 -124 2 -178 -1 -219
-12z"
                  />
                  <path
                    d="M3503 3135 c-111 -31 -183 -83 -223 -162 -21 -40 -25 -62 -25 -133 1
-167 66 -247 281 -344 220 -100 263 -139 251 -228 -11 -83 -89 -120 -251 -119
-99 0 -115 2 -214 32 -35 10 -68 17 -72 14 -15 -9 -40 -98 -40 -141 0 -40 2
-43 43 -59 71 -29 183 -45 305 -45 230 1 356 53 430 179 25 42 27 54 27 156 0
96 -3 115 -24 154 -38 72 -112 136 -214 185 -51 24 -131 62 -179 85 -98 47
-118 71 -118 141 0 58 37 94 116 110 67 14 179 8 264 -15 48 -13 56 -13 71 1
20 18 39 80 39 128 0 33 -4 39 -37 53 -54 24 -356 29 -430 8z"
                  />
                  <path
                    d="M2007 3123 c-15 -2 -32 -13 -37 -23 -7 -13 -10 -208 -8 -570 3 -477
5 -552 18 -560 8 -6 55 -9 105 -8 86 3 89 4 96 28 4 14 7 194 8 399 l1 375
111 -190 c61 -104 118 -197 127 -206 20 -24 84 -24 104 0 8 9 69 105 134 212
l119 195 3 -394 c1 -271 6 -398 13 -408 8 -9 38 -13 100 -13 78 0 90 2 99 20
17 31 9 1115 -8 1132 -18 18 -173 18 -195 -1 -9 -7 -80 -114 -158 -237 -78
-124 -145 -227 -149 -229 -4 -3 -74 101 -155 230 -137 218 -149 235 -183 245
-37 10 -91 11 -145 3z"
                  />
                </g>
              </svg>
              <span className="menu-label">SMS</span>
              </div>
              {showSms?<ExpandMoreIcon/>:<KeyboardArrowRightIcon/>}
            </NavLink>
          </li>

        {showSms && (
          <>
              <li className="hidden-li">
                <NavLink to="smsprovider">
                  {/* <img src={OffersIcon} alt="dashboard icon" /> */}
                  <span className="menu-label">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SMS Provider
                  </span>
                </NavLink>
              </li>
              <li className="hidden-li">
                <NavLink to="smspackage">
                  {/* <img src={OffersIcon} alt="dashboard icon" /> */}
                  <span className="menu-label">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SMS Package
                  </span>
                </NavLink>
              </li>
              <li className="hidden-li">
                <NavLink to="whatsapppackage">
                  {/* <img src={OffersIcon} alt="dashboard icon" /> */}
                  <span className="menu-label">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;WhatsApp Package
                  </span>
                </NavLink>
              </li>
              <li className="hidden-li">
                <NavLink to="userpackage">
                  {/* <img src={OffersIcon} alt="dashboard icon" /> */}
                  <span className="menu-label">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;User List
                  </span>
                </NavLink>
              </li>
          </>
        )}
           {/* refund */}
          <li>
            <NavLink
              to="refund"
              style={(isActive) => isActive && setActiveTab("refund")}
            >
              {/* <img src={RefundIcon} alt="dashboard icon" /> */}
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="512.000000pt"
                height="512.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  stroke="none"
                >
                  <path
                    d="M2370 5114 c-116 -11 -276 -38 -390 -66 -851 -209 -1528 -882 -1745
-1732 -54 -215 -69 -341 -69 -591 0 -398 68 -700 239 -1050 280 -574 783
-1017 1385 -1219 127 -42 344 -96 387 -96 39 0 33 -15 -32 -80 l-65 -65 108
-108 107 -107 232 233 233 232 -201 260 c-111 143 -203 262 -205 264 -5 6
-234 -170 -234 -179 0 -4 25 -40 55 -78 30 -39 55 -73 55 -75 0 -11 -229 45
-342 83 -676 230 -1189 784 -1363 1472 -171 672 10 1401 472 1908 433 474
1015 721 1643 697 1220 -47 2146 -1124 2005 -2332 -82 -703 -504 -1309 -1135
-1629 -63 -32 -116 -60 -118 -61 -3 -3 106 -265 113 -273 1 -1 60 26 131 62
702 353 1182 1017 1300 1801 25 168 25 513 0 680 -105 688 -475 1270 -1054
1658 -131 87 -346 197 -497 252 -122 45 -334 99 -475 120 -101 15 -447 27
-540 19z"
                  />
                  <path
                    d="M2408 3768 l-3 -111 -52 -18 c-90 -30 -174 -81 -238 -144 -246 -243
-207 -616 86 -811 97 -64 185 -92 337 -108 142 -15 198 -35 256 -92 53 -51 70
-90 71 -159 0 -142 -129 -246 -305 -246 -42 0 -94 6 -118 15 -96 35 -169 110
-187 194 l-7 32 -150 0 -150 0 6 -47 c33 -230 190 -402 439 -477 15 -5 17 -19
17 -116 l0 -110 150 0 149 0 3 110 3 111 67 23 c232 81 382 282 382 511 0 114
-26 197 -95 294 -106 151 -262 234 -474 251 -125 11 -175 25 -240 70 -65 45
-100 110 -100 185 1 92 49 160 150 213 45 24 61 27 155 27 94 0 110 -3 155
-27 85 -44 136 -106 150 -181 l7 -37 144 0 c123 0 146 2 151 16 10 27 -35 184
-69 243 -68 115 -194 214 -331 260 l-52 18 -3 111 -3 112 -149 0 -149 0 -3
-112z"
                  />
                </g>
              </svg>
              <span className="menu-label">Refund</span>
            </NavLink>
          </li>

        {/* staff */}
          <li onClick={staffMenuClick}>
            <NavLink 
             className="icon-tool-tip-container"
              to="dashboard"
              style={(isActive) => isActive && setActiveTab("dashboard")}
             >
              <div style={{display:"flex",alignItems:"center",width:"50%"}}>

              
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="174.98"
                height="174.971"
                viewBox="0 0 174.98 174.971"
              >
                <g
                  id="Group_3074"
                  data-name="Group 3074"
                  transform="translate(0.25 0.25)"
                >
                  <path
                    id="Path_1213"
                    data-name="Path 1213"
                    d="M187.316,497.145a11.876,11.876,0,0,0-20.3-8.368c-.957.957-2.7,3.015-3.643,4.165a2.824,2.824,0,1,0,4.349,3.6c1.488-1.788,2.715-3.2,3.286-3.769a6.285,6.285,0,0,1,4.445-1.855h.029a6.153,6.153,0,0,1,6.185,6.2,6.279,6.279,0,0,1-1.865,4.445,99.981,99.981,0,0,1-9.982,7.653,17.914,17.914,0,0,0-15.461-8.9h-41.4a20.749,20.749,0,0,0-14.785,6.126L15.425,589.189a8.876,8.876,0,0,0,0,12.533l55.439,55.429a8.866,8.866,0,0,0,12.524,0l82.737-82.738a20.788,20.788,0,0,0,6.127-14.794V518.23a17.3,17.3,0,0,0-.358-3.565,108.316,108.316,0,0,0,11.905-9.094A11.909,11.909,0,0,0,187.316,497.145Zm-25.183,73.267L79.4,653.15a3.2,3.2,0,0,1-4.532,0L19.425,597.721a3.207,3.207,0,0,1,0-4.532l82.737-82.738a15.192,15.192,0,0,1,10.794-4.474h41.4a12.277,12.277,0,0,1,10.775,6.426c-3.344,2.213-7.083,4.561-11.045,6.88-.126-.135-.251-.271-.387-.406a11.886,11.886,0,1,0,3.083,5.372c3.45-2.01,6.764-4.068,9.818-6.049v41.417h0A15.166,15.166,0,0,1,162.133,570.413Zm-19.356-41.871a2.835,2.835,0,0,0,3.8,1.256c1.662-.831,3.3-1.7,4.948-2.59a6.216,6.216,0,1,1-10.61-4.329,6.164,6.164,0,0,1,4.4-1.817,6.239,6.239,0,0,1,3.585,1.141q-2.392,1.3-4.861,2.551A2.826,2.826,0,0,0,142.778,528.542Z"
                    transform="translate(-12.835 -485.269)"
                    stroke-width="0.5"
                  />
                  <path
                    id="Path_1214"
                    data-name="Path 1214"
                    d="M24.081,491.227a2.825,2.825,0,0,0-2.822,2.822v59.7a2.827,2.827,0,1,0,5.653,0v-59.7A2.827,2.827,0,0,0,24.081,491.227Z"
                    transform="translate(60.145 -433.653)"
                    stroke-width="0.5"
                  />
                  <path
                    id="Path_1215"
                    data-name="Path 1215"
                    d="M21.588,496.856a11.876,11.876,0,1,0,16.795,0A11.881,11.881,0,0,0,21.588,496.856ZM34.383,509.64a6.214,6.214,0,1,1,0-8.793,6.228,6.228,0,0,1,0,8.793Z"
                    transform="translate(32.923 -414.997)"
                    stroke-width="0.5"
                  />
                  <path
                    id="Path_1216"
                    data-name="Path 1216"
                    d="M26,496.856a11.869,11.869,0,1,0,16.785,0A11.881,11.881,0,0,0,26,496.856ZM38.8,509.64a6.214,6.214,0,1,1,0-8.793A6.223,6.223,0,0,1,38.8,509.64Z"
                    transform="translate(71.154 -414.997)"
                    stroke-width="0.5"
                  />
                </g>
              </svg>
              <span className="menu-label">Staff</span>
             
              </div>
              {showStaff?<ExpandMoreIcon/>:<KeyboardArrowRightIcon/>}
             </NavLink>
          </li>

        {
          showStaff && (
            <>
              {/* dashboard */}
                 <li className="hidden-li">
                 <NavLink
                  to="dashboard"
                  style={(isActive) => isActive && setActiveTab("dashboard")}
                >
                 
                  <span className="menu-label">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dashboard
                  </span>
                </NavLink>
                 </li>
               <li className="hidden-li" onClick={hrmClick}>
                 <NavLink
                    className="icon-tool-tip-container"
                    to="department"
                    style={(isActive) => isActive && setActiveTab("hrm")}
                  >
             
                <span className="menu-label">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;HRM</span>
                {showHrm?<ExpandMoreIcon/>:<KeyboardArrowRightIcon/>}
              {/* <KeyboardArrowRightIcon /> */}
            </NavLink>
          </li>
          {
            showHrm && (
              <>
               <Tooltip title="Department" className="left-menu-tool-tip">
                 <li className="hidden-li">
                   <NavLink
                     to="department"
                     style={(isActive) => isActive && setActiveTab("department")}
                   >
                      <span className="menu-label">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Department
                      </span>
                   </NavLink>
                 </li>
               </Tooltip>
               <Tooltip title="Designation" className="left-menu-tool-tip">
                 <li className="hidden-li">
                   <NavLink
                     to="designation"
                     style={(isActive) => isActive && setActiveTab("designation")}
                   >
                      <span className="menu-label">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Designation
                      </span>
                   </NavLink>
                 </li>
               </Tooltip>
               <Tooltip title="Manage Employee" className="left-menu-tool-tip">
                 <li className="hidden-li">
                   <NavLink
                     to="manageEmployee"
                     style={(isActive) => isActive && setActiveTab("manageEmployee")}
                   >
                      <span className="menu-label">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Manage Employee
                      </span>
                   </NavLink>
                 </li>
               </Tooltip>
               <Tooltip title="Add Employee" className="left-menu-tool-tip">
                 <li className="hidden-li">
                   <NavLink
                     to="addEmployee"
                     style={(isActive) => isActive && setActiveTab("addEmployee")}
                   >
                      <span className="menu-label">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Add Employee
                      </span>
                   </NavLink>
                 </li>
               </Tooltip>
               <Tooltip title="Add Document" className="left-menu-tool-tip">
                 <li className="hidden-li">
                   <NavLink
                     to="addDocument"
                     style={(isActive) => isActive && setActiveTab("addDocument")}
                   >
                      <span className="menu-label">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Add Document
                      </span>
                   </NavLink>
                 </li>
               </Tooltip>
              </>
            )
          }
          {/* attendance */}
          <li className="hidden-li">
            <NavLink
              to="attendance"
              style={(isActive) => isActive && setActiveTab("attendance")}
            >
             
              <span className="menu-label">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Attendance</span>
              {/* <KeyboardArrowRightIcon /> */}
            </NavLink>
          </li>
          {/* leave */}
               <li className="hidden-li" onClick={leaveOnclick}>
                 <NavLink
                    className="icon-tool-tip-container"
                    to="leaveApplication"
                    style={(isActive) => isActive && setActiveTab("leaveApplication")}
                  >
             
                <span className="menu-label">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Leave</span>
              {/* <KeyboardArrowRightIcon /> */}
              {showLeave?<ExpandMoreIcon/>:<KeyboardArrowRightIcon/>}
                </NavLink>
             </li>

              {
                showLeave && (
                  <>
                  <li className="hidden-li">
                    <NavLink
                      to="leaveApplication"
                      style={(isActive) => isActive && setActiveTab("leaveApplication")}
                    >
                       <span className="menu-label">
                         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Leave Application
                       </span>
                    </NavLink>
                  </li>

                  <li className="hidden-li">
                    <NavLink
                      to="holiday"
                      style={(isActive) => isActive && setActiveTab("holiday")}
                    >
                       <span className="menu-label">
                         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Holiday
                       </span>
                    </NavLink>
                  </li>
                  
                  <li className="hidden-li">
                    <NavLink
                      to="addLeaveType"
                      style={(isActive) => isActive && setActiveTab("holiday")}
                    >
                       <span className="menu-label">
                         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Add Leave Type
                       </span>
                    </NavLink>
                  </li>

                </>
                )
              }

              {/* payroll */}
               <li className="hidden-li" onClick={payrollClick}>
                 <NavLink
                    className="icon-tool-tip-container"
                    to="employeeSalary"
                    style={(isActive) => isActive && setActiveTab("employeeSalary")}
                  >
             
                <span className="menu-label">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Payroll</span>
                {showPayroll?<ExpandMoreIcon/>:<KeyboardArrowRightIcon/>}
              {/* <KeyboardArrowRightIcon /> */}
                </NavLink>
             </li>
              {
                showPayroll && (
                  <>
                    <li className="hidden-li">
                    <NavLink
                      to="employeeSalary"
                      style={(isActive) => isActive && setActiveTab("employeeSalary")}
                    >
                       <span className="menu-label">
                         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Employee Salary
                       </span>
                    </NavLink>
                  </li>

                    <li className="hidden-li">
                    <NavLink
                      to="addPayroll"
                      style={(isActive) => isActive && setActiveTab("addPayroll")}
                    >
                       <span className="menu-label">
                         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Add Payroll
                       </span>
                    </NavLink>
                  </li>
                    <li className="hidden-li">
                    <NavLink
                      to="payrollItem"
                      style={(isActive) => isActive && setActiveTab("payrollItem")}
                    >
                       <span className="menu-label">
                         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Payroll Item
                       </span>
                    </NavLink>
                  </li>
                    <li className="hidden-li">
                    <NavLink
                      to="payslip"
                      style={(isActive) => isActive && setActiveTab("payslip")}
                    >
                       <span className="menu-label">
                         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Payslip
                       </span>
                    </NavLink>
                  </li>
                  </>
                )
              }

               <li className="hidden-li" onClick={loanClick}>
                 <NavLink
                     className="icon-tool-tip-container"
                    to="addNewLoan"
                    style={(isActive) => isActive && setActiveTab("addNewLoan")}
                  >
             
                <span className="menu-label">
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Loan</span>
                 {showLoan?<ExpandMoreIcon/>:<KeyboardArrowRightIcon/>}
              {/* <KeyboardArrowRightIcon /> */}
                </NavLink>
             </li>

              {
                showLoan && (
                  <>
                    <li className="hidden-li">
                    <NavLink
                      to="addNewLoan"
                      style={(isActive) => isActive && setActiveTab("addPayroll")}
                    >
                       <span className="menu-label">
                         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Add New Loan
                       </span>
                    </NavLink>
                  </li>
                    <li className="hidden-li">
                    <NavLink
                      to="LoanReport"
                      style={(isActive) => isActive && setActiveTab("addPayroll")}
                    >
                       <span className="menu-label">
                         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Loan Report
                       </span>
                    </NavLink>
                  </li>
                    <li className="hidden-li">
                    <NavLink
                      to="loanApproval"
                      style={(isActive) => isActive && setActiveTab("addPayroll")}
                    >
                       <span className="menu-label">
                         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Loan Approvals
                       </span>
                    </NavLink>
                  </li>
                  </>
                )
              }

            </>
          )
        }

           {/* customer support */}
          <li>
            <NavLink
              to="customerSupport"
              style={(isActive) => isActive && setActiveTab("customerSupport")}
            >
              {/* <img src={CustomerSupportIcon} alt="dashboard icon" /> */}
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="512.000000pt"
                height="512.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  stroke="none"
                >
                  <path
                    d="M2300 4995 c-492 -61 -947 -283 -1295 -630 -370 -370 -598 -865 -640
-1387 l-7 -87 -58 -35 c-116 -72 -207 -201 -236 -335 -20 -95 -20 -698 1 -794
40 -192 205 -359 392 -398 179 -37 334 29 411 176 l27 50 0 570 0 570 -27 50
c-28 54 -96 123 -145 149 -17 8 -51 20 -77 27 l-47 12 6 46 c41 315 87 475
206 713 279 557 811 948 1435 1054 128 21 378 29 509 15 602 -65 1121 -381
1447 -881 157 -240 263 -522 298 -790 23 -178 26 -156 -27 -169 -25 -7 -59
-19 -76 -27 -49 -26 -117 -95 -145 -149 l-27 -50 0 -570 0 -570 27 -50 c28
-54 96 -123 145 -149 17 -8 51 -20 76 -27 l47 -11 0 -152 c0 -168 -12 -235
-58 -320 -39 -72 -127 -158 -200 -195 -101 -51 -163 -61 -387 -61 l-200 0 -29
56 c-36 68 -113 137 -186 166 -52 21 -71 22 -315 22 -250 0 -262 -1 -320 -23
-84 -34 -174 -124 -204 -206 -33 -86 -27 -216 13 -293 36 -71 99 -132 172
-168 l59 -29 280 0 280 0 57 28 c66 32 136 99 169 162 l23 43 240 5 c270 5
308 11 441 76 145 72 261 187 331 331 61 123 67 156 72 387 l4 211 57 36 c119
73 208 199 237 335 20 94 20 698 0 792 -29 134 -120 263 -235 334 l-58 36 -12
122 c-45 463 -214 864 -519 1227 -302 361 -759 631 -1225 725 -231 46 -487 57
-707 30z m-1671 -2331 l31 -26 0 -513 0 -512 -26 -27 c-57 -56 -192 -22 -272
69 -68 78 -72 102 -72 470 0 367 4 392 71 469 82 93 203 125 268 70z m4048 -2
c57 -30 120 -105 138 -165 12 -40 15 -116 15 -372 0 -368 -4 -392 -72 -470
-80 -91 -215 -125 -272 -69 l-26 27 0 512 0 512 28 28 c25 25 32 27 87 22 33
-2 79 -14 102 -25z m-1261 -2106 c28 -28 34 -42 34 -75 0 -53 -22 -97 -60
-116 -42 -21 -447 -22 -489 -1 -41 22 -61 59 -61 112 0 39 5 51 34 80 l34 34
237 0 237 0 34 -34z"
                  />
                  <path
                    d="M1715 3840 c-200 -27 -361 -167 -422 -365 -17 -55 -18 -106 -18 -655
0 -588 0 -596 22 -666 60 -189 220 -326 416 -355 l77 -11 0 -142 c0 -168 14
-228 66 -286 73 -80 190 -106 284 -62 31 14 122 96 285 256 l240 236 345 0
c190 0 374 5 410 10 78 12 188 65 252 120 64 55 124 148 151 234 22 70 22 78
22 666 0 549 -1 600 -18 655 -51 166 -173 293 -336 347 l-66 23 -825 1 c-454
1 -852 -2 -885 -6z m1725 -256 c67 -31 106 -68 137 -132 l28 -57 0 -575 c0
-562 0 -576 -21 -620 -30 -65 -69 -107 -128 -138 l-51 -27 -421 -5 -421 -5
-258 -252 c-141 -139 -261 -253 -266 -253 -5 0 -9 95 -9 210 0 291 -2 294
-200 302 -92 4 -123 9 -156 26 -66 34 -101 69 -131 130 l-28 57 0 570 c0 443
3 578 13 607 32 89 112 159 203 177 24 5 409 8 854 8 799 -2 811 -2 855 -23z"
                  />
                  <path
                    d="M1928 2970 c-72 -22 -128 -96 -128 -170 0 -81 65 -158 147 -175 66
-13 155 32 188 96 19 36 19 122 0 158 -20 39 -69 78 -113 91 -42 11 -56 11
-94 0z"
                  />
                  <path
                    d="M2502 2966 c-49 -17 -98 -70 -112 -121 -35 -125 90 -252 211 -216 97
29 154 126 129 216 -20 73 -98 133 -170 133 -14 0 -40 -5 -58 -12z"
                  />
                  <path
                    d="M3087 2966 c-45 -16 -83 -49 -103 -88 -18 -35 -18 -121 1 -157 33
-64 122 -109 188 -96 80 17 147 98 147 176 -1 117 -125 205 -233 165z"
                  />
                </g>
              </svg>
              <span className="menu-label">Customer Support</span>
            </NavLink>
          </li>
             {/* roles and permission */}
          <li>
            <NavLink
              to="rolesAndPermission"
              style={(isActive) => isActive && setActiveTab("rolesAndPermission")}
            >
              {/* <img src={DeviceSettingsIcon} alt="dashboard icon" /> */}
              <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="35.08" 
              height="33.619" 
              viewBox="0 0 35.08 33.619"
              >
  <g id="user_2_" transform="translate(-0.133 500.576)">
    <path id="Path_1364" data-name="Path 1364" d="M91.663-500.537a7.4,7.4,0,0,0-5.968,5.241,7.165,7.165,0,0,0-.247,2.73,7.333,7.333,0,0,0,5.419,6.352,5.246,5.246,0,0,0,1.852.185,5.6,5.6,0,0,0,1.784-.158,7.366,7.366,0,0,0,4.761-3.876,7.277,7.277,0,0,0-3.355-9.8,6.728,6.728,0,0,0-2.95-.713A9.947,9.947,0,0,0,91.663-500.537Zm2.072,2.236a5.194,5.194,0,0,1,3.931,3.711,5.522,5.522,0,0,1,0,2.593,5.046,5.046,0,0,1-2.717,3.293,4.79,4.79,0,0,1-2.229.514,5.094,5.094,0,0,1-5.076-4.521,4.882,4.882,0,0,1,1.441-4.13A4.945,4.945,0,0,1,93.735-498.3Z" transform="translate(-79.424)" fill="#fff"/>
    <path id="Path_1365" data-name="Path 1365" d="M5.866-244.632a6.765,6.765,0,0,0-3.684,1.948,6.676,6.676,0,0,0-1.955,3.759,24.356,24.356,0,0,0-.089,3.636c.021,2.929.027,3.025.165,3.21a1.87,1.87,0,0,0,.329.329c.185.144.22.144,9.1.165,8.767.014,8.918.014,9.179-.123a1.086,1.086,0,0,0,0-1.921c-.254-.137-.439-.137-8.431-.137H2.313l.021-2.456c.027-2.449.027-2.449.213-3a4.638,4.638,0,0,1,1.18-1.921,4.876,4.876,0,0,1,1.921-1.187l.549-.185,7.031-.021c7.889-.021,7.621-.034,8.705.473,1.008.473,1.688.288,1.928-.521s-.5-1.461-2.257-1.941l-.659-.185-7.272-.014C7.65-244.728,6.312-244.714,5.866-244.632Z" transform="translate(0 -238.303)" fill="#fff"/>
    <path id="Path_1366" data-name="Path 1366" d="M326.2-244.6a3.837,3.837,0,0,0-2.593,2.332,5.085,5.085,0,0,0-.178,1.893l-.021,1.482-.473.048a2.572,2.572,0,0,0-2.209,1.468l-.226.46v6.38l.226.46a2.811,2.811,0,0,0,1.372,1.3l.391.158h9.124l.391-.158a2.811,2.811,0,0,0,1.372-1.3l.226-.46v-6.38l-.226-.46a2.572,2.572,0,0,0-2.209-1.468l-.473-.048-.021-1.482a5.207,5.207,0,0,0-.171-1.88,3.758,3.758,0,0,0-2.291-2.25A4.173,4.173,0,0,0,326.2-244.6Zm1.386,2.2a1.5,1.5,0,0,1,.775.748c.11.233.13.453.13,1.523v1.255h-2.881v-1.269c0-1.118.014-1.3.13-1.53A1.458,1.458,0,0,1,327.586-242.395Zm3.746,5.858c.1.075.11.432.11,2.819v2.73l-.151.1c-.137.1-.652.11-4.239.11s-4.1-.014-4.239-.11l-.151-.1v-2.737c0-2.593.007-2.744.13-2.826C322.976-236.681,331.174-236.674,331.332-236.536Z" transform="translate(-298.39 -238.344)" fill="#fff"/>
  </g>
</svg>
              <span className="menu-label">Roles And Permission</span>
            </NavLink>
          </li>
          {/* device settings */}
          <li>
            <NavLink
              to="deviceSettings"
              style={(isActive) => isActive && setActiveTab("deviceSettings")}
            >
              {/* <img src={DeviceSettingsIcon} alt="dashboard icon" /> */}
              <svg
                id="settings_2_"
                data-name="settings (2)"
                xmlns="http://www.w3.org/2000/svg"
                width="340.826"
                height="340.826"
                viewBox="0 0 340.826 340.826"
              >
                <path
                  id="Path_463"
                  data-name="Path 463"
                  d="M181.108,340.826h-21.39a31.412,31.412,0,0,1-31.376-31.375v-7.237a137.6,137.6,0,0,1-21.366-8.869l-5.128,5.128a31.376,31.376,0,0,1-44.377,0L42.352,283.352a31.374,31.374,0,0,1,0-44.377l5.124-5.124a137.6,137.6,0,0,1-8.869-21.366H31.375A31.411,31.411,0,0,1,0,181.109V159.718a31.412,31.412,0,0,1,31.376-31.375h7.236a137.632,137.632,0,0,1,8.869-21.366l-5.128-5.128a31.376,31.376,0,0,1,0-44.377l15.12-15.119a31.372,31.372,0,0,1,44.377,0l5.124,5.124a137.726,137.726,0,0,1,21.366-8.869V31.375A31.411,31.411,0,0,1,159.718,0h21.39a31.411,31.411,0,0,1,31.375,31.375v7.237a137.592,137.592,0,0,1,21.366,8.869l5.128-5.128a31.376,31.376,0,0,1,44.377,0l15.118,15.118a31.374,31.374,0,0,1,0,44.377l-5.124,5.124a137.6,137.6,0,0,1,8.869,21.366h7.236a31.412,31.412,0,0,1,31.376,31.375v21.391a31.412,31.412,0,0,1-31.376,31.375h-7.236a137.629,137.629,0,0,1-8.869,21.366l5.128,5.128a31.376,31.376,0,0,1,0,44.377l-15.119,15.119a31.372,31.372,0,0,1-44.377,0l-5.124-5.124a137.719,137.719,0,0,1-21.366,8.869v7.237A31.411,31.411,0,0,1,181.108,340.826Zm-70.794-68.451a117.7,117.7,0,0,0,30.509,12.665,9.985,9.985,0,0,1,7.49,9.668v14.743a11.419,11.419,0,0,0,11.406,11.4h21.39a11.419,11.419,0,0,0,11.406-11.4V294.708a9.984,9.984,0,0,1,7.49-9.668,117.7,117.7,0,0,0,30.509-12.665,9.985,9.985,0,0,1,12.144,1.534L253.1,284.353a11.4,11.4,0,0,0,16.125,0l15.129-15.128a11.4,11.4,0,0,0,0-16.126l-10.448-10.448a9.986,9.986,0,0,1-1.534-12.143A117.68,117.68,0,0,0,285.04,200a9.985,9.985,0,0,1,9.668-7.49h14.743a11.419,11.419,0,0,0,11.406-11.405V159.718a11.419,11.419,0,0,0-11.406-11.405H294.708a9.985,9.985,0,0,1-9.668-7.49,117.7,117.7,0,0,0-12.664-30.509,9.986,9.986,0,0,1,1.534-12.143l10.444-10.444a11.4,11.4,0,0,0,0-16.126L269.231,56.475a11.4,11.4,0,0,0-16.126,0L242.658,66.918a9.985,9.985,0,0,1-12.144,1.534,117.7,117.7,0,0,0-30.509-12.664,9.984,9.984,0,0,1-7.49-9.668V31.375A11.419,11.419,0,0,0,181.109,19.97h-21.39a11.419,11.419,0,0,0-11.406,11.405V46.119a9.985,9.985,0,0,1-7.49,9.668,117.7,117.7,0,0,0-30.509,12.664,9.986,9.986,0,0,1-12.144-1.534L87.728,56.473a11.4,11.4,0,0,0-16.125,0L56.473,71.6a11.4,11.4,0,0,0,0,16.126L66.917,98.171a9.986,9.986,0,0,1,1.534,12.143,117.679,117.679,0,0,0-12.664,30.509,9.985,9.985,0,0,1-9.668,7.49H31.376A11.42,11.42,0,0,0,19.97,159.718v21.391a11.419,11.419,0,0,0,11.406,11.405H46.119A9.985,9.985,0,0,1,55.787,200a117.7,117.7,0,0,0,12.664,30.509,9.986,9.986,0,0,1-1.534,12.143L56.473,253.1a11.4,11.4,0,0,0,0,16.126L71.6,284.352a11.4,11.4,0,0,0,16.126,0l10.447-10.448a10.032,10.032,0,0,1,12.145-1.534Z"
                  transform="translate(0 0)"
                />
                <path
                  id="Path_464"
                  data-name="Path 464"
                  d="M218.757,292.913a74.156,74.156,0,1,1,74.156-74.156A74.24,74.24,0,0,1,218.757,292.913Zm0-128.343a54.186,54.186,0,1,0,54.186,54.187A54.248,54.248,0,0,0,218.757,164.57Z"
                  transform="translate(-48.343 -48.343)"
                />
              </svg>
              <span className="menu-label">Device Settings</span>
            </NavLink>
          </li>
            {/* notification settings */}
            <li>
            <NavLink
              to="notificationSettings"
              style={(isActive) => isActive && setActiveTab("deviceSettings")}
            >
              {/* <img src={DeviceSettingsIcon} alt="dashboard icon" /> */}
              <svg
                id="settings_2_"
                data-name="settings (2)"
                xmlns="http://www.w3.org/2000/svg"
                width="340.826"
                height="340.826"
                viewBox="0 0 340.826 340.826"
              >
                <path
                  id="Path_463"
                  data-name="Path 463"
                  d="M181.108,340.826h-21.39a31.412,31.412,0,0,1-31.376-31.375v-7.237a137.6,137.6,0,0,1-21.366-8.869l-5.128,5.128a31.376,31.376,0,0,1-44.377,0L42.352,283.352a31.374,31.374,0,0,1,0-44.377l5.124-5.124a137.6,137.6,0,0,1-8.869-21.366H31.375A31.411,31.411,0,0,1,0,181.109V159.718a31.412,31.412,0,0,1,31.376-31.375h7.236a137.632,137.632,0,0,1,8.869-21.366l-5.128-5.128a31.376,31.376,0,0,1,0-44.377l15.12-15.119a31.372,31.372,0,0,1,44.377,0l5.124,5.124a137.726,137.726,0,0,1,21.366-8.869V31.375A31.411,31.411,0,0,1,159.718,0h21.39a31.411,31.411,0,0,1,31.375,31.375v7.237a137.592,137.592,0,0,1,21.366,8.869l5.128-5.128a31.376,31.376,0,0,1,44.377,0l15.118,15.118a31.374,31.374,0,0,1,0,44.377l-5.124,5.124a137.6,137.6,0,0,1,8.869,21.366h7.236a31.412,31.412,0,0,1,31.376,31.375v21.391a31.412,31.412,0,0,1-31.376,31.375h-7.236a137.629,137.629,0,0,1-8.869,21.366l5.128,5.128a31.376,31.376,0,0,1,0,44.377l-15.119,15.119a31.372,31.372,0,0,1-44.377,0l-5.124-5.124a137.719,137.719,0,0,1-21.366,8.869v7.237A31.411,31.411,0,0,1,181.108,340.826Zm-70.794-68.451a117.7,117.7,0,0,0,30.509,12.665,9.985,9.985,0,0,1,7.49,9.668v14.743a11.419,11.419,0,0,0,11.406,11.4h21.39a11.419,11.419,0,0,0,11.406-11.4V294.708a9.984,9.984,0,0,1,7.49-9.668,117.7,117.7,0,0,0,30.509-12.665,9.985,9.985,0,0,1,12.144,1.534L253.1,284.353a11.4,11.4,0,0,0,16.125,0l15.129-15.128a11.4,11.4,0,0,0,0-16.126l-10.448-10.448a9.986,9.986,0,0,1-1.534-12.143A117.68,117.68,0,0,0,285.04,200a9.985,9.985,0,0,1,9.668-7.49h14.743a11.419,11.419,0,0,0,11.406-11.405V159.718a11.419,11.419,0,0,0-11.406-11.405H294.708a9.985,9.985,0,0,1-9.668-7.49,117.7,117.7,0,0,0-12.664-30.509,9.986,9.986,0,0,1,1.534-12.143l10.444-10.444a11.4,11.4,0,0,0,0-16.126L269.231,56.475a11.4,11.4,0,0,0-16.126,0L242.658,66.918a9.985,9.985,0,0,1-12.144,1.534,117.7,117.7,0,0,0-30.509-12.664,9.984,9.984,0,0,1-7.49-9.668V31.375A11.419,11.419,0,0,0,181.109,19.97h-21.39a11.419,11.419,0,0,0-11.406,11.405V46.119a9.985,9.985,0,0,1-7.49,9.668,117.7,117.7,0,0,0-30.509,12.664,9.986,9.986,0,0,1-12.144-1.534L87.728,56.473a11.4,11.4,0,0,0-16.125,0L56.473,71.6a11.4,11.4,0,0,0,0,16.126L66.917,98.171a9.986,9.986,0,0,1,1.534,12.143,117.679,117.679,0,0,0-12.664,30.509,9.985,9.985,0,0,1-9.668,7.49H31.376A11.42,11.42,0,0,0,19.97,159.718v21.391a11.419,11.419,0,0,0,11.406,11.405H46.119A9.985,9.985,0,0,1,55.787,200a117.7,117.7,0,0,0,12.664,30.509,9.986,9.986,0,0,1-1.534,12.143L56.473,253.1a11.4,11.4,0,0,0,0,16.126L71.6,284.352a11.4,11.4,0,0,0,16.126,0l10.447-10.448a10.032,10.032,0,0,1,12.145-1.534Z"
                  transform="translate(0 0)"
                />
                <path
                  id="Path_464"
                  data-name="Path 464"
                  d="M218.757,292.913a74.156,74.156,0,1,1,74.156-74.156A74.24,74.24,0,0,1,218.757,292.913Zm0-128.343a54.186,54.186,0,1,0,54.186,54.187A54.248,54.248,0,0,0,218.757,164.57Z"
                  transform="translate(-48.343 -48.343)"
                />
              </svg>
              <span className="menu-label">Notification Settings</span>
            </NavLink>
          </li>
           {/*company profile */}
           <li>
            <NavLink
              to="companyProfile"
              style={(isActive) => isActive && setActiveTab("deviceSettings")}
            >
              {/* <img src={DeviceSettingsIcon} alt="dashboard icon" /> */}
              <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
 >
<path d="M2430 4903 c-485 -34 -905 -190 -1290 -477 -124 -92 -355 -324 -450
-451 -250 -333 -410 -730 -461 -1140 -16 -128 -16 -422 0 -547 56 -439 225
-846 497 -1190 74 -94 278 -298 372 -372 338 -267 722 -430 1157 -492 142 -20
444 -23 580 -5 427 56 802 207 1140 461 114 85 334 299 419 408 337 428 509
924 509 1462 0 538 -172 1034 -509 1462 -87 111 -307 325 -424 412 -254 189
-540 326 -835 400 -235 59 -496 84 -705 69z m368 -224 c814 -89 1517 -656
1781 -1436 149 -439 149 -927 0 -1366 -162 -478 -503 -898 -936 -1154 -525
-309 -1168 -379 -1744 -189 -561 184 -1027 598 -1275 1132 -268 577 -260 1253
21 1829 286 586 829 1012 1466 1149 64 14 151 29 195 34 113 13 378 14 492 1z"/>
<path d="M2384 4351 c-303 -75 -526 -327 -564 -640 -26 -209 44 -427 187 -580
142 -155 304 -234 507 -248 219 -15 412 61 576 226 146 147 212 307 213 516 1
292 -155 543 -418 670 -49 24 -122 50 -162 59 -94 21 -248 19 -339 -3z m295
-206 c173 -41 323 -174 383 -340 26 -73 35 -209 19 -287 -38 -181 -184 -343
-360 -399 -85 -27 -222 -29 -306 -5 -183 53 -337 218 -376 404 -16 78 -7 214
19 287 91 252 363 400 621 340z"/>
<path d="M2455 2664 c-180 -17 -388 -77 -535 -155 -130 -70 -208 -127 -319
-234 -258 -249 -397 -548 -426 -921 -6 -66 -4 -89 10 -117 34 -72 -45 -68
1212 -65 1128 3 1128 3 1206 25 265 75 470 286 538 554 18 70 18 268 0 339
-66 265 -275 479 -538 552 -75 21 -98 22 -593 24 -283 1 -533 0 -555 -2z m405
-241 c-11 -16 -35 -46 -52 -68 -45 -58 -103 -189 -122 -272 -20 -92 -20 -234
0 -326 19 -83 77 -214 122 -272 17 -22 41 -52 52 -67 l22 -28 -426 0 -426 0 0
271 c0 303 -4 324 -65 353 -18 9 -38 16 -45 16 -7 0 -27 -7 -45 -16 -44 -21
-65 -67 -65 -143 l0 -61 -145 0 c-80 0 -145 3 -145 8 0 4 16 34 36 66 170 283
472 492 794 550 47 9 159 14 303 15 l229 1 -22 -27z m683 12 c177 -46 324
-183 378 -354 29 -91 29 -231 0 -322 -56 -176 -218 -322 -399 -360 -78 -16
-214 -7 -287 19 -252 91 -400 363 -340 621 37 157 161 308 303 368 104 44 240
55 345 28z m-1733 -940 l0 -105 -210 0 -211 0 6 38 c13 78 17 98 26 135 l10
37 189 0 190 0 0 -105z"/>
<path d="M3144 2221 c-44 -27 -60 -77 -41 -124 28 -66 33 -67 315 -67 l254 0
29 29 c47 48 37 130 -21 164 -24 15 -62 17 -267 17 -217 0 -241 -2 -269 -19z"/>
<path d="M3137 1790 c-38 -30 -52 -80 -33 -123 26 -63 45 -67 311 -67 203 0
241 2 265 17 58 34 68 116 21 164 l-29 29 -255 0 c-240 0 -256 -1 -280 -20z"/>
</g>
</svg>
              <span className="menu-label">Company Profile</span>
            </NavLink>
          </li>
      </ul>
    </div>
  );
};

export default LeftMenu;
